module.exports = __webpack_public_path__ + "static/media/jquery.71e98dc5.svg";